var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.preview)?_c('main-preview',{directives:[{name:"scroll-lock",rawName:"v-scroll-lock",value:(_vm.preview),expression:"preview"}],on:{"close":_vm.closeMa}}):_vm._e(),_c('div',{staticClass:"cyber-color"},[_c('lounge-intro'),_c('chilim-text'),_c('cyber-poster'),_c('hookah-slider'),_c('menu-book'),_c('cyber-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }